import React, { useState } from 'react';
import Modal from './Modal';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import BaseText from '../ui/typography/BaseText';
import { FONT_SIZE, API_ERROR_CODES, API_CODE, HUBSPOT_INTEGRATION, EMAIL_JS } from '../../constants/enum';
import Input from '../ui/Input/InputSM';
import PrimaryButton from '../ui/buttons/PrimaryButton';
import H2HeaderText from '../ui/typography/H2HeaderText';
import { send } from '@emailjs/browser';

export default function ContactModal({ iconOnly, fill, children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    reset();
    setIsSubmitted(false);
    setIsModalOpen(false);
  };
  const schema = yup.object({
    firstName: yup.string().required('First Name'),
    lastName: yup.string().required('Last Name'),
    phoneNumber: yup.string().required('Phone Number'),
    email: yup.string().email().required('Email')
  });
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });
  function templateParamsForMail(data) {
    let templateParams = {
      userFirstName: data?.firstName,
      userLastName: data?.lastName,
      userEmail: data?.email,
      userPhone: data?.phoneNumber
    };
    return templateParams;
  }
  const sendingEmailJs = async (data, templateId) => {
    await send(EMAIL_JS.EMAIL_JS_SERVICE_ID, templateId, templateParamsForMail(data), EMAIL_JS.PUBLIC_KEY).then(
      function (response) {
        console.log(response);
      },
      function (error) {
        console?.log(error);
      }
    );
  };
  const onSubmit = async (data) => {
    setIsLoading(true);
    await sendingEmailJs(data, EMAIL_JS?.CONTACT_TEMPLATE_ID);

    var payload = {
      fields: [
        {
          name: 'firstname',
          value: data?.firstName ? data?.firstName : ''
        },
        {
          name: 'lastname',
          value: data?.lastName ? data?.lastName : ''
        },
        {
          name: 'email',
          value: data?.email ? data?.email : ''
        },
        {
          name: 'phone',
          value: data?.phoneNumber ? data?.phoneNumber : ''
        }
      ],
      context: {
        pageUri: 'https://air-corporate.com/',
        pageName: 'contact-us'
      }
    };
    var final_data = JSON.stringify(payload);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', HUBSPOT_INTEGRATION?.CONTACT_US);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(final_data);
    xhr.onreadystatechange = async function () {
      if (xhr.readyState == 4 && xhr.status == API_CODE.STATUS_200) {
        setIsSubmitted(true);
      } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_400) {
        alert(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_403) {
        alert(xhr.responseText);
      } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_404) {
        alert(xhr.responseText);
      }
      setIsLoading(false);
    };
  };
  return (
    <div>
      <div onClick={handleOpenModal}>{children}</div>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        {isSubmitted ? (
          <div className="pt-12 pb-32">
            <H2HeaderText title={'Thanks for Submitting the form'} />
          </div>
        ) : (
          <div>
            <BaseText
              className="md:whitespace-pre-line"
              fontSize={FONT_SIZE?.PX_20}
              title={`Have any questions about your new \ncompany in Hong Kong?`}
            />
            <BaseText textColor="text-gray-200" title="Fill the form and we will reach out soon!" />
            <Input
              label="Your First Name"
              inputProps={{ ...register(`firstName`) }}
              error={errors?.firstName?.message}
            />
            <Input label="Your Last Name" inputProps={{ ...register(`lastName`) }} error={errors?.lastName?.message} />
            <Input
              label="Your phone number"
              inputProps={{ ...register(`phoneNumber`) }}
              error={errors?.phoneNumber?.message}
            />
            <Input label="Your email" inputProps={{ ...register(`email`) }} error={errors?.email?.message} />
            <PrimaryButton
              type="submit"
              onClick={handleSubmit(onSubmit)}
              padding="16px"
              fontSize={FONT_SIZE?.PX_16}
              className="w-full mt-6 mb-4 hover:bg-gray-700 hover:text-white"
              caption="Send"
            />
          </div>
        )}
      </Modal>
    </div>
  );
}

ContactModal.defaultProps = {
  iconOnly: true
};
